import React from "react";

const isMakeAWillLink = (link) =>
    /^#?\/?wills?$/i.test((link?.href || "").trim()) ||
    (link?.label || "").toLowerCase().trim() === "make a will";

/**
 * Renders a single CMS nav link. Handles the "Make a Will" exception
 * (opens /makeawill in a new tab) and forwards everything else as a normal
 * anchor (hash links scroll smoothly via Lenis).
 */
export const NavLink = ({ link, variant = "desktop", onNavigate }) => {
    const baseTestId =
        variant === "mobile"
            ? `nav-mobile-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`
            : `nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`;
    const className =
        variant === "mobile" ? "nav-link font-body text-lg" : "nav-link font-body";

    if (isMakeAWillLink(link)) {
        return (
            <a
                href="/makeawill"
                target="_blank"
                rel="noopener noreferrer"
                onClick={onNavigate}
                className={className}
                data-testid={baseTestId}
            >
                {link.label}
            </a>
        );
    }
    return (
        <a href={link.href} className={className} onClick={onNavigate} data-testid={baseTestId}>
            {link.label}
        </a>
    );
};
